<!-- partial:partia/__mobile-nav.html -->
<aside class="sigma_aside sigma_aside-left" [ngClass]="navmethod ? 'open' : ''">
    <app-mobile-menu></app-mobile-menu>
</aside>
<div class="sigma_aside-overlay aside-trigger-left" (click)="toggleNav()"></div>
<!-- partial -->
<!-- partial:partia/__header.html -->
<header class="sigma_header header-1 header-absolute header-light">
    <div class="sigma_header-top">
        <div class="container">
            <div class="sigma_header-top-inner">
                <ul class="sigma_header-top-links">
                    <li class="menu-item"> <a href="tel:+123456789"> <i class="fal fa-phone"></i> (+123) 123 4567
                            890</a> </li>
                    <li class="menu-item"> <a href="mailto:info@example.com"> <i class="fal fa-envelope"></i>
                            info@example.com</a> </li>
                </ul>
                <ul class="sigma_sm">
                    <li> <a href="#"> <i class="fab fa-facebook-f"></i> </a> </li>
                    <li> <a href="#"> <i class="fab fa-twitter"></i> </a> </li>
                    <li> <a href="#"> <i class="fab fa-instagram"></i> </a> </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Middle Header Start -->
    <div class="sigma_header-middle">
        <div class="container">
            <nav class="navbar">
                <!-- Logo Start -->
                <div class="sigma_logo-wrapper">
                    <a class="navbar-brand" routerLink="/">
                        <img src="assets/img/logo-2.png" alt="logo">
                    </a>
                </div>
                <!-- Logo End -->
                <!-- Menu -->
                <ul class="navbar-nav">
                    <li class="menu-item" [ngClass]="item.child === true ? 'menu-item-has-children' : ''"
                        *ngFor="let item of navigation">
                        <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText}}</a>
                        <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
                        <ul class="sub-menu" *ngIf="item.child">
                            <li class="menu-item" [ngClass]="item.child === true ? 'menu-item-has-children' : ''"
                                *ngFor="let item of item.submenu">
                                <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText}}</a>
                                <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
                                <ul class="sub-menu" *ngIf="item.child">
                                    <li class="menu-item" *ngFor="let item of item.submenu">
                                        <a routerLink="{{item.link}}">{{item.linkText}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
                <!-- Controls -->
                <div class="sigma_header-controls style-2">
                    <ul class="sigma_header-controls-inner">
                        <!-- Desktop Toggler -->
                        <li><a routerLink="/contact" class="d-none d-lg-block sigma_btn-custom">Free Consultation</a>
                        </li>
                        <!-- Mobile Toggler -->
                        <li class="aside-toggler aside-trigger-left" (click)="toggleNav()">
                            <span></span>
                            <span></span>
                            <span></span>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <!-- Middle Header End -->
</header>
<!-- partial -->